import { DatabaseWrapper } from '../../../shared/databases/database.wrapper';
import { Database } from '../../../shared/databases/database';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { RepConnWrapper } from '../../repconn/repconn.wrapper';
import { ObjectWrapper } from 'src/app/shared/wrappers/object.wrapper';
import { Attribute } from 'src/app/shared/models/domain/attribute';

export class GoogleDoubleClickSearchWrapper extends DatabaseWrapper {
    dbTyp_Id: number;
    name: string;
    code: string;
    showLoadPropertiesTab: boolean = false;
    constructor(database: Database) {
        super(database);

        this.dbTyp_Id = DatabaseEnum.google_doubleclick_search.ID;
        this.name = DatabaseEnum.google_doubleclick_search.NAME;
        this.code = DatabaseEnum.google_doubleclick_search.CODE;
        this.equivalentTag = DatabaseEnum.google_doubleclick_search.EQUIVALENT_TAG;
        this.showDatabaseTab = false;
        this.isFileType = true;
        this.importFileProperties();
        this.showDataDescription = false;

    }
    validateRepConn(repConnWrapper: RepConnWrapper): void {
        console.log('factory:: GoogleDoubleClickSearchWrapper:: validateRepConn()::');

        if (repConnWrapper.repConn.conn.host == '') {
            repConnWrapper.inValid_Cds.push('ESM00673');
        } else if (repConnWrapper.repConn.conn.fileloc == "") {
            repConnWrapper.inValid_Cds.push('FILE_LOC');
        } else if (repConnWrapper.repConn.conn.agency_Id == '') {
            repConnWrapper.inValid_Cds.push('ESM00675');
        }/*else if( repConnWrapper.repConn.conn.advertiser_Id == '' ){
            repConnWrapper.inValid_Cds.push('ESM00676');
        }*/
        if (repConnWrapper.repConn.conn.flagent_Id == -1) {
            repConnWrapper.inValid_Cds.push('ESM00202');
        }

    }
    getAttributeColumns(objectWrapper: ObjectWrapper,
        attributes: Array<Attribute> = new Array<Attribute>(), component: any = null,hideRowSelection:boolean=true): Array<any> {
        return [
            this.attributeTabulator.getCheckBoxColumn(objectWrapper,hideRowSelection),
            this.attributeTabulator.getSrt_Order(),
            this.attributeTabulator.getAttr_Id(),
            this.attributeTabulator.getAttrNm(objectWrapper,component),
            this.attributeTabulator.getAttrDTyp_Id(objectWrapper, attributes, component),
            /// this.attributeTabulator.getSavedColumn(),
            /// this.attributeTabulator.getReportPerspective(),
        ]
    }

    getSourceAttributeColumns(objectWrapper: ObjectWrapper = null, isComplex: boolean = false,
        isShowPIIColumn: boolean = false, isGoogleAnalytics: boolean = false, isEncryptedFlag: boolean = false, component:any): Array<any> {
        return [
            this.attributeTabulator.getCheckBoxColumn(objectWrapper),
            this.attributeTabulator.getSrt_Order(),
            this.attributeTabulator.getAttr_Id(),
            this.attributeTabulator.getClevel(objectWrapper, isComplex),
            this.attributeTabulator.getAttrNm(objectWrapper,component),
            this.attributeTabulator.getAttrDTyp_Id(objectWrapper, objectWrapper.object.attributes, component),
            this.attributeTabulator.getAttrPrec(objectWrapper),
            this.attributeTabulator.getAttrScale(objectWrapper),
            this.attributeTabulator.getAttrPiiIdentifierFlag(objectWrapper, isShowPIIColumn),
            this.attributeTabulator.getEncryptedFlag(objectWrapper, isEncryptedFlag),
            this.attributeTabulator.getLnk_Attr_Id(objectWrapper),
            this.attributeTabulator.getLnk_Attr_Datatype(objectWrapper),
            this.attributeTabulator.getValid_Cd(objectWrapper,component),
        ]
    }

    importFileProperties() {
        this.showFileTypeGroup = true;
        this.showDelimiter = true;
        this.showFixedWidth = true;
    }

    readFileCutOffLength(type: string): number {
        if( type == "FILE" ){
            return 49; //default 50 lines index starts from 0
        }

        return -1;
    }
}
